import React from "react";
import "../css/loading-component.css";

const LoadingComponent = () => (
  <div className="loading-overlay">
    <div className="loading-spinner">
      <div className="loading-spinner-ring" />
      <div className="loading-logo">
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Company Logo" />
      </div>
    </div>
    <p className="loading-text">Loading...</p>
  </div>
);

export default LoadingComponent;